import { request } from './api';
import { getCookie } from '@/utils/cookies';

/** 获取最新消息列表 */
export const getMessageListApi = (data?: any): Promise<any> => {
    return request({
        method: 'get',
        url: `/messages`,
        params: data,
    }, false, false).then(res => res);
};

/** 获取消息未读数量 */
export const getUnreadCountApi = (): Promise<any> => {
    const token = getCookie('baai-data-admin-token-key');
    if (!token) {
        return Promise.resolve(null);
    }
    return request({
        method: 'get',
        url: `/messages/unread-count`,
    }, false, false).then(res => res);
};

/** 获取消息详情 */
export const getMessageDetailApi = (message_id: string): Promise<any> => {
    return request({
        method: 'get',
        url: `/messages/${message_id}`,
    }).then(res => res);
};

